export default __webpack_public_path__ + "static/media/Graphics_Banner-1-min.0c09bae5.png";